import styled from "styled-components";

export const TimelineRoot = styled.section`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Header = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  gap: 16px;
`;

export const Title = styled.h2`
  margin: 0;
  color: ${({ theme }) => theme.palette.colors.text};
  font-size: 32px;
  line-height: 1.15;
`;

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.palette.colors.muted};
  font-size: 16px;
  font-weight: 700;
`;

export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

export const Empty = styled.div`
  padding: 36px 0;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.palette.colors.muted};
`;
